import { AddressTracker } from './components/addressTracker';

export const App = () => {
	return (
		<div className='h-screen w-screen'>
			<AddressTracker />
		</div>
	);
};
